<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4>Performance Tracking By Employee</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <div class="col-md-12">
            <div class="alert alert-danger" v-if="error">
              <strong>{{ error }}</strong>
            </div>
          </div>
        </div>
        <div class="row flex">
          <div class="col-md-3">
            <h4>Area</h4>
            <v-select
              placeholder="SELECT AREA"
              v-model="shirtOrderStatusId"
              :options="areas"
              @input="changeArea"
              :reduce="(areas) => areas.id"
            />
          </div>
          <div class="col-md-3">
            <h4>STATION</h4>
            <v-select
              placeholder="SELECT STATION"
              v-model="stationId"
              :options="stations"
              label="name"
              :reduce="(stations) => stations.id"
            />
          </div>
          <div class="col-md-3">
            <h4>From Date</h4>
            <VueCtkDateTimePicker
              format="YYYY-MM-DD"
              formatted="DD MMM YYYY"
              color="coral"
              v-model="fromDate"
              :no-label="true"
              :only-date="true"
              :auto-close="true"
              label="From Date"
            />
          </div>

          <div class="col-md-3">
            <h4>To Date</h4>
            <VueCtkDateTimePicker
              format="YYYY-MM-DD"
              formatted="DD MMM YYYY"
              color="coral"
              v-model="toDate"
              :no-label="true"
              :only-date="true"
              :auto-close="true"
              label="To Date"
            />
          </div>

          <div class="col-md-3 text-align-bottom">
            <button class="btn btn-primary" @click="getDataByEmployee()">
              GENERATE
            </button>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <vue-good-table
              :columns="columns"
              styleClass="table table-hover table-bordered"
              :rows="employees"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'time_delta'">
                  <span
                    :class="'text-bold ' + timeDeltaColor(props.row.time_delta)"
                    >{{ props.row.time_delta }} %</span
                  >
                </span>
                <span v-else-if="props.column.field == 'rank'">
                  <span>{{ props.row.rank }} of {{ employees.length }}</span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import AreaStatusMatching from "./tools/AreaStatusMatching.json";
import moment from "moment";
import { VueGoodTable } from "vue-good-table";
import columns from "./tools/EmployeeColumns.json";
import _ from "lodash";

export default {
  components: {
    VueCtkDateTimePicker,
    VueGoodTable,
  },
  data() {
    return {
      fromDate: moment().format(),
      toDate: moment().format(),
      areas: [],
      stations: [],
      columns: columns,
      stationId: null,
      shirtOrderStatusId: null,
      employees: [],
      error: null,
    };
  },
  async mounted() {
    $(".pt-sidebar").removeClass("active");
    $(".pt-employee").addClass("active");
    this.getAreas();
    let area = this.$route.params.area;
    let station = this.$route.params.station;
    if (area != undefined && station != undefined) {
      this.shirtOrderStatusId = area * 1;
      this.stationId = station * 1;
      this.getDataByEmployee();
    }
    this.getStations();
  },
  methods: {
    getAreas() {
      let data = AreaStatusMatching.en;
      data.forEach((val) => {
        this.areas.push(val);
      });
    },
    async getStations() {
      let res = await axios.get(
        "performance_tracking/station/listings/" + this.shirtOrderStatusId
      );
      this.stations = res.data;
    },
    changeArea() {
      this.stationId = null;
      this.getStations();
    },
    async getDataByEmployee() {
      if (this.shirtOrderStatusId == null) {
        this.error = "Please Select Area";
      } else if (this.stationId == null) {
        this.error = "Please Select Station";
      } else {
        this.error = null;
        let res = await axios.get("/performance_tracking/by_employee", {
          params: {
            from_date: moment(this.fromDate).format("YYYY-MM-DD"),
            to_date: moment(this.toDate).format("YYYY-MM-DD"),
            shirt_order_status_id: this.shirtOrderStatusId,
            station_id: this.stationId,
          },
        });
        let data = res.data;
        this.employees = data;
        this.calculateRank();
      }
    },
    timeDeltaColor(value) {
      if (value > 0) {
        return "text-danger";
      } else if (value < 0) {
        return "text-success";
      }
    },
    calculateRank() {
      let data = this.employees;
      let array = _.orderBy(data, ["time_delta"], ["asc"]);
      var rank = 1;
      for (var i = 0; i < array.length; i++) {
        // increase rank only if current score less than previous
        if (i > 0 && array[i].time_delta > array[i - 1].time_delta) {
          rank++;
        }
        array[i].rank = rank;
      }
      this.employees = array;
    },
  },
};
</script>

<style scoped>
.text-align-bottom {
  align-self: flex-end;
}
.flex {
  display: flex;
}
.text-capitalize {
  text-transform: capitalize !important;
}
</style>
